<template>
  <div class="container">
    <steps :active="step" simple style="margin-top: 20px">
      <step title="选择设备/组件"></step>
      <step title="核对信息/数量"></step>
    </steps>
    <ChooseDevice
      style="height: 100%;"
      v-show="step === 0"
      @nexStep="nexStep"
      @select="select"
    />
    <CheckInfo
      style="height: 100%;"
      v-if="step === 1"
      :selectDevice="selectDevice"
      :selectSubDevice="selectSubDevice"
      @prevStep="prevStep"
    />
  </div>
</template>

<script>
import {
  Steps,
  Step,
} from '@/components';
import ChooseDevice from './choose-device';
import CheckInfo from './check-info';

export default {
  name: "DeviceDeliveryCreate",
  components: {
    Steps,
    Step,
    ChooseDevice,
    CheckInfo,
  },
  data() {
    return {
      step: 0,
      selectDevice: [],
      selectSubDevice: [],
    };
  },
  methods: {
    prevStep() {
      this.step -= 1;
    },
    nexStep() {
      this.step += 1;
      if (this.step !== 0 && this.step % 2 === 0) {
        this.step = 0;
      }
    },
    select({selectDevice, selectSubDevice}) {
      this.selectDevice = selectDevice;
      this.selectSubDevice = selectSubDevice;
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
</style>
